var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},[(_vm.mostrarIconeFinanceiro)?_c('span',{staticClass:"text-success ml-1"},[_c('i',{staticClass:"fa fa-check-circle fa-lg",attrs:{"title":"Processo Recebido/Quitado"}})]):_vm._e(),(_vm.statusLabel)?_c('app-status',{staticClass:"text-success ml-1",attrs:{"status":_vm.statusLabel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }